import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const TermsAndConditionsPage = () => {
  return (
    <div className="min-h-screen section-padding">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="display-md text-white mb-6">Terms & Conditions</h1>
          </div>
          <Card className="feature-card">
            <CardHeader>
              <CardTitle className="h2 text-white">Effective Date: 17 October 2025</CardTitle>
              <CardDescription className="body-md">
                Welcome to <strong>GrowSquare</strong>, a CRM platform operated by <strong>CXSquare Solutions (Zed Associates Pty Ltd)</strong>, based in Sydney, Australia.
                By accessing or using GrowSquare, you agree to be bound by these Terms & Conditions (“Terms”).
                If you do not agree, do not use our services.
              </CardDescription>
            </CardHeader>

            <CardContent className="prose prose-invert max-w-none text-slate-300 space-y-6">
              <h4>1. Eligibility</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare is <strong>only available to businesses</strong></span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">By using GrowSquare, you represent and warrant that you are legally authorized to act on behalf of your business entity</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">You must be at least 18 years old and capable of entering into legally binding agreements</span>
                </div>
              </span>
              <h4>2. Account Registration & Access</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">You must provide <strong>accurate, complete, and current information</strong> when registering</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">You are responsible for maintaining the <strong>confidentiality of your account credentials</strong></span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">You agree to notify GrowSquare immediately of any unauthorized use</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare may suspend or terminate accounts that violate these Terms</span>
                </div>
              </span>
              <h4>3. Free Trial & Subscription Plans</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare may offer <strong>free trials</strong> to new users</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Trial periods are <strong>limited in duration</strong> and may be discontinued or modified at GrowSquare’s discretion</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Paid subscription plans automatically continue unless cancelled according to our <strong>Refund & Cancellation Policy</strong></span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare reserves the right to <strong>modify plan features or pricing</strong> with notice</span>
                </div>
              </span>
              <h4>4. Billing, Payments & Taxes</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    Payments for subscription plans are <strong>processed in advance</strong> on a recurring basis (monthly or yearly)</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">You authorize GrowSquare to charge the payment method provided</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">All fees are <strong>non-refundable except as explicitly stated</strong></span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    You are responsible for applicable taxes, duties, or levies related to your subscription</span>
                </div>
              </span>
              <h4>5. Refund & Cancellation Policy</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    You may cancel your subscription at any time via the account settings</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    <strong>No automatic refunds</strong> are provided for partial subscription periods, except where required by law</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    Refunds for billing errors or disputes will be considered at GrowSquare’s discretion</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    Trial accounts <strong>expire automatically</strong> at the end of the trial period unless upgraded</span>
                </div>
              </span>

              <h4>6. Acceptable Use Policy</h4>
              <span>
                <span className="body-sm text-slate-400">You agree not to use GrowSquare to:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    Violate any applicable law or regulation</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    Transmit harmful, abusive, defamatory, obscene, or offensive content</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    Engage in unauthorized access or attempts to interfere with
                    GrowSquare’s infrastructure</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">
                    Resell or distribute GrowSquare services without prior written consent</span>
                </div>
                <span className="body-sm text-slate-400">GrowSquare reserves the right to <strong>suspend or terminate accounts</strong> violating
                  these rules</span>
              </span>

              <h4>7. Service Availability & SLA/Uptime</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare is hosted on <strong>Linode (Akamai)</strong> infrastructure</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare strives for <strong>99.5% uptime,</strong> excluding scheduled maintenance
                    or events outside our control</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Scheduled maintenance will be communicated in advance where feasible</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare is <strong>not liable for downtime</strong> caused by internet disruptions,
                    force majeure, or user actions</span>
                </div>
              </span>

              <h4>8. Data Ownership & Privacy</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">You retain <strong>full ownership of your data</strong> entered into GrowSquare</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare may process your data for the purpose of providing services,
                    analytics, and improving platform performance</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Our <strong>Privacy Policy</strong> governs the collection, use, and storage of personal
                    data</span>
                </div>
              </span>

              <h4>9. Intellectual Property</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">All <strong>software, designs, trademarks, and content</strong> of GrowSquare
                    remain the property of CXSquare Solutions</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Users may not copy, reproduce, or create derivative works from
                    GrowSquare except as explicitly authorized</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Users retain ownership of their <strong>customized content and data</strong></span>
                </div>
              </span>

              <h4>10. AI Liability and Data Accuracy</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400"><strong>AI-Generated Outputs</strong>: GrowSquare may incorporate artificial
                    intelligence (AI) features, such as predictive analytics, automation, or
                    content generation, to enhance user experience. These AI-generated
                    outputs are provided as tools to assist users and should not be solely
                    relied upon for critical business decisions</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400"><strong>No Warranty of Accuracy</strong>: CXSquare Solutions does not warrant or
                    guarantee the accuracy, completeness, or reliability of any AI-generated
                    content or recommendations. Users acknowledge that AI outputs may be
                    based on algorithms that can produce errors or inaccuracies</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400"><strong>User Responsibility</strong>: Users are solely responsible for verifying the
                    accuracy and appropriateness of AI-generated outputs before using them
                    in business operations. CXSquare Solutions disclaims any liability for
                    decisions made based on AI-generated content.</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400"><strong>Limitation of Liability</strong>: To the fullest extent permitted by applicable law,
                    CXSquare Solutions shall not be liable for any direct, indirect, incidental,
                    special, consequential, or punitive damages arising from the use or
                    reliance on AI-generated outputs, even if advised of the possibility of such
                    damages</span>
                </div>
              </span>

              <h4>11. Security & Hosting</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare implements <strong>reasonable technical and organizational
                    measures</strong> to protect user data</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Hosting is provided via <strong>Linode (Akamai),</strong> and GrowSquare is not liable
                    for third-party infrastructure issues beyond its control</span>
                </div>
              </span>

              <h4>12. Termination & Suspension</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare may terminate or suspend accounts for violations of these
                    Terms, failure to pay fees, or misuse of the platform</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Upon termination, access to data may be restricted; users are responsible
                    for exporting their data prior to termination</span>
                </div>
              </span>

              <h4>13. Confidentiality</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Users must treat GrowSquare <strong>confidential information,</strong> including
                    platform features or internal communications, as confidential</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Confidentiality obligations survive termination of your account</span>
                </div>
              </span>

              <h4>14. Disclaimer & Limitation of Liability</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare is provided <strong>“as is”</strong> without warranties of any kind</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">CXSquare Solutions is <strong>not liable for indirect, incidental, or
                    consequential damages</strong> arising from use of GrowSquare</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Liability for direct damages is limited to the fees paid for the subscription
                    during the <strong>12 months preceding the claim</strong></span>
                </div>
              </span>
              <h4>15. Governing Law & Dispute Resolution</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">These Terms are governed by <strong>Australian law</strong></span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Disputes will first attempt to be resolved through <strong>good faith
                    negotiations</strong></span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">If unresolved, disputes may be submitted to the <strong>courts of Sydney,
                    Australia,</strong> or an agreed-upon arbitration forum</span>
                </div>
              </span>
              <h4>16. Modifications to Terms</h4>
              <span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">GrowSquare may modify these Terms at any time</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Users will be notified of significant changes via email or platform
                    notification</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Continued use of GrowSquare constitutes <strong>acceptance of the updated
                    Terms</strong></span>
                </div>
              </span>
              <h4>17. Contact Information</h4>
              <span>
                <span className="body-sm text-slate-400">
                  For questions or concerns regarding these Terms:
                </span>
                <span>
                  <p className="text-400 font-medium">CXSquare Solutions (Zed Associates Pty Ltd)</p>
                </span>
                <span>
                  <p className="text-400 font-medium">Sydney, Australia</p>
                </span>
                <span>
                  <p><a href="mailto:support@growsquare.com" className="text-green-400">
                    support@growsquare.com
                  </a></p>
                </span>
              </span>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
